var isFunction = function isFunction(value) {
  return typeof value === 'function';
};

export default isFunction;